import momentDate from 'utils/momentDate'
import tulkojumi from 'utils/tulkojumi'
import { getThumbUrlFromItem } from 'utils/deepProps'

const transformData = (data, lang) => {
  const { teksti } = data

  const banner = {
    image: data.page &&
      data.page.length > 0 &&
      data.page[0].images &&
      data.page[0].images.length > 0 &&
      data.page[0].images[0].src,
    links: data.menu &&
      data.menu.length > 0 &&
      data.menu[0].items &&
      (data.menu[0].items || []).map(item => ({
        label: item.title,
        location: item.path,
        rewrite_url: item.rewrite_url,
        rewrite_source: item.rewrite_source,
        rewrite_target: item.rewrite_target
    }))
  }

  // const aktuali = {
  //   order: 1,
  //   title: tulkojumi(teksti, 'aktuali'),
  //   icon: null,
  //   items: (data.aktuali || []).map(item => {
  //     if (!item) {
  //       return null
  //     }

  //     let acf = {}
  //     if (item && item.acf) {
  //       acf = JSON.parse(item.acf)
  //     }

  //     const dateOrLabel = (acf && acf.label) ? acf.label :
  //       (item.date_created ? momentDate(item.date_created, lang) : '')

  //     return (item && item.acf) ? {
  //       title: item.title,
  //       subtitle: dateOrLabel,
  //       actionLabel: acf && acf.link_text,
  //       thumbnail: getThumbUrlFromItem(item),
  //       location: item.path,
  //       rewrite_url: item.rewrite_url,
  //       rewrite_source: item.rewrite_source,
  //       rewrite_target: item.rewrite_target,
  //       post_type: item.post_type,
  //       template: item.template
  //     } : null
  //   })
  // }

  // const saites = {
  //   aktuali: [
  //     {
  //       menu_order: 0,
  //       path:
  //         "/aktuali/pastaiga-izgaismota-liepaja-notiks-no-21-lidz-24-oktobrim/",
  //       target: "_self",
  //       title: "Pastaiga “Izgaismotā Liepāja” notiks no 21. līdz 24. oktobrim",
  //     },
  //     {
  //       menu_order: 1,
  //       path: "/aktuali/liepajas-pasakumu-kalendars/",
  //       target: "_self",
  //       title: "Liepājas pasākumu kalendārs",
  //     },
  //     {
  //       menu_order: 2,
  //       path: "/aktuali/pasarga-sevi-no-koronavirusa-covid-19/",
  //       target: "_self",
  //       title: "Pasargā sevi no koronavīrusa Covid-19!",
  //     },
  //   ],
  //   noderigi: [
  //     {
  //       menu_order: 0,
  //       path:
  //         "/aktuali/pastaiga-izgaismota-liepaja-notiks-no-21-lidz-24-oktobrim/",
  //       target: "_self",
  //       title: "Pastaiga “Izgaismotā Liepāja” notiks no 21. līdz 24. oktobrim",
  //     },
  //     {
  //       menu_order: 1,
  //       path: "/aktuali/liepajas-pasakumu-kalendars/",
  //       target: "_self",
  //       title: "Liepājas pasākumu kalendārs",
  //     },
  //     {
  //       menu_order: 2,
  //       path: "/aktuali/pasarga-sevi-no-koronavirusa-covid-19/",
  //       target: "_self",
  //       title: "Pasargā sevi no koronavīrusa Covid-19!",
  //     },
  //   ],
  //   temas: [
  //     {
  //       menu_order: 0,
  //       path:
  //         "https://google.com",
  //       target: "_blank",
  //       title: "Meklē ar Google",
  //     },
  //   ],
  // };

  const jaunakasZinas = {
    order: 2,
    title: tulkojumi(teksti, 'jaunakas_zinas'),
    icon: null,
    items: (data.jaunumi || []).posts.map(item => item ? {
        title: item.title,
        date: momentDate(item.date_created, lang),
        location: item.path,
        post_type: item.post_type,
        template: item.template
      } : null),
    more: {
      label: tulkojumi(teksti, 'skatit_vairak_jaunumus'),
      location: data.jaunumiLapa &&
        data.jaunumiLapa.length > 0 &&
        data.jaunumiLapa[0].path
    }
  }

  const noderigiIcons = ['document', 'sort-alpha', 'contacts']
  const noderigiAccents = ['primary', 'default', 'secondary']

  const noderigi = {
    order: 3,
    title: tulkojumi(teksti, 'noderigi'),
    icon: null,
    items: (data.noderigi || []).map((item, i) => ({
      title: item.nosaukums,
      icon: noderigiIcons[i],
      accent: noderigiAccents[i],
      location: item.post && item.post.path,
      rewrite_url: item.post && item.post.rewrite_url,
      rewrite_source: item.post && item.post.rewrite_source,
      rewrite_target: item.post && item.post.rewrite_target
    }))
  }

  const parPilsetu = {
    order: 4,
    title: tulkojumi(teksti, 'par_pilsetu'),
    icon: null,
    items: (data.parpilsetu || []).map(item => item ? {
        title: item.title,
        thumbnail: getThumbUrlFromItem(item),
        location: item.path,
        rewrite_url: item.rewrite_url,
        rewrite_source: item.rewrite_source,
        rewrite_target: item.rewrite_target,
        post_type: item.post_type,
        template: item.template
      } : null)
  }

  const videoGalerija = {
    order: 5,
    title: tulkojumi(teksti, 'video_galerija'),
    icon: null,
    items: (data.video_galerija || []).map(item => {
      const acf = item ? JSON.parse(item.acf) : {}
      return item ? {
        title: item.title,
        video: {
          src: '',
          poster: getThumbUrlFromItem(item),
          duration: acf && acf.vide_length
        },
        location: item.path,
        post_type: item.post_type,
        template: item.template
      } : null
    })
  }

  const composedData = {
    banner,
    sections: {
      // aktuali,
      saites: data.saites,
      parPilsetu,
      noderigi,
      jaunakasZinas,
      videoGalerija
    }
  }

  return composedData
}

export default transformData



// WEBPACK FOOTER //
// ./src/pages/Sakums/transformData.js